/* Chimi Theme — theme.js */
'use strict';

document.addEventListener('DOMContentLoaded', () => {

  const overlay    = document.getElementById('ch-overlay');
  const mobNav     = document.getElementById('ch-mob-nav');
  const cartDrawer = document.getElementById('ch-cart-drawer');

  function openPanel(el) {
    if (!el) return;
    [mobNav, cartDrawer].forEach(p => { if (p) { p.classList.remove('is-open'); p.setAttribute('aria-hidden','true'); } });
    el.classList.add('is-open'); el.setAttribute('aria-hidden','false');
    if (overlay && el === cartDrawer) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeAll() {
    [mobNav, cartDrawer].forEach(p => { if (p) { p.classList.remove('is-open'); p.setAttribute('aria-hidden','true'); } });
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.getElementById('ch-ham')?.addEventListener('click',       () => openPanel(mobNav));
  document.getElementById('ch-nav-close')?.addEventListener('click', closeAll);
  document.getElementById('ch-cart-open')?.addEventListener('click', () => openPanel(cartDrawer));
  document.getElementById('ch-cart-close')?.addEventListener('click', closeAll);
  overlay?.addEventListener('click', closeAll);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });

  const fmt = c => '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  function setCount(n) {
    const el = document.getElementById('ch-cart-count');
    if (!el) return;
    el.textContent = n > 0 ? `(${n})` : '';
    el.classList.toggle('is-hidden', n === 0);
  }

  function refreshCart() {
    fetch('/cart.js').then(r => r.json()).then(cart => {
      setCount(cart.item_count);
      const body   = document.getElementById('ch-cart-body');
      const sub    = document.getElementById('ch-cart-subtotal');
      const footer = document.getElementById('ch-cart-footer');
      if (sub) sub.textContent = fmt(cart.total_price);
      if (!body) return;
      if (cart.items.length === 0) {
        body.innerHTML = `<div class="ch-cart__empty"><p class="ch-cart__empty-text">Your bag is empty</p><a href="/collections/all" class="ch-btn ch-btn--outline" style="width:auto;padding:.65rem 1.5rem;font-size:.65rem;">Shop Now</a></div>`;
        if (footer) footer.style.display = 'none';
      } else {
        if (footer) footer.style.display = '';
        body.innerHTML = cart.items.map(item => `
          <div class="ch-cart-item">
            <a href="${item.url}" class="ch-cart-item__img"><img src="${item.image}" alt="${item.title}" loading="lazy"></a>
            <div>
              <p class="ch-cart-item__name">${item.product_title}</p>
              ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="ch-cart-item__variant">${item.variant_title}</p>` : ''}
              <p class="ch-cart-item__price">${fmt(item.final_price)}</p>
              <div class="ch-cart-item__actions">
                <div class="ch-qty">
                  <button class="ch-qty__btn" data-key="${item.key}" data-action="minus">−</button>
                  <span class="ch-qty__val">${item.quantity}</span>
                  <button class="ch-qty__btn" data-key="${item.key}" data-action="plus">+</button>
                </div>
                <button class="ch-cart-item__remove" data-key="${item.key}">Remove</button>
              </div>
            </div>
          </div>`).join('');
      }
      bindCartEvents();
    }).catch(() => {});
  }

  function bindCartEvents() {
    document.querySelectorAll('.ch-qty__btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        const item = btn.closest('.ch-cart-item');
        let qty = parseInt(item?.querySelector('.ch-qty__val')?.textContent || 1);
        qty = btn.dataset.action === 'plus' ? qty + 1 : Math.max(0, qty - 1);
        fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ id: key, quantity: qty }) })
          .then(r => r.json()).then(() => refreshCart());
      });
    });
    document.querySelectorAll('.ch-cart-item__remove').forEach(btn => {
      btn.addEventListener('click', () => {
        fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ id: btn.dataset.key, quantity: 0 }) })
          .then(r => r.json()).then(() => refreshCart());
      });
    });
  }

  bindCartEvents();

  window.chQuickAdd = function(variantId, btn, event) {
    if (event) event.preventDefault();
    if (!variantId) return;
    const orig = btn.textContent;
    btn.textContent = '—'; btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    })
    .then(r => { if (!r.ok) return r.json().then(e => { throw new Error(e.description); }); return r.json(); })
    .then(() => { btn.textContent = 'Added'; refreshCart(); openPanel(cartDrawer); setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 2000); })
    .catch(err => { btn.textContent = err.message || 'Error'; btn.disabled = false; });
  };

  /* PDP */
  const pdpForm = document.getElementById('ch-pdp-form');
  const addBtn  = document.getElementById('ch-pdp-add');
  if (pdpForm && addBtn) {
    pdpForm.addEventListener('submit', e => {
      e.preventDefault();
      const id = pdpForm.querySelector('[name="id"]')?.value;
      if (!id) return;
      const orig = addBtn.textContent;
      addBtn.textContent = '—'; addBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: parseInt(id), quantity: 1 })
      })
      .then(r => { if (!r.ok) return r.json().then(e => { throw new Error(e.description); }); return r.json(); })
      .then(() => { addBtn.textContent = 'Added to Bag'; refreshCart(); openPanel(cartDrawer); setTimeout(() => { addBtn.textContent = orig; addBtn.disabled = false; }, 2500); })
      .catch(err => { addBtn.textContent = err.message || 'Try Again'; addBtn.disabled = false; });
    });
  }

  document.querySelectorAll('.ch-vbtn').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.closest('.ch-pdp__variants')?.querySelectorAll('.ch-vbtn').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      const inp = btn.closest('form')?.querySelector('[name="id"]');
      if (inp && btn.dataset.variantId) inp.value = btn.dataset.variantId;
    });
  });

  document.querySelectorAll('.ch-acc-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const body = btn.nextElementSibling;
      const isOpen = body.classList.contains('is-open');
      document.querySelectorAll('.ch-acc-body').forEach(b => b.classList.remove('is-open'));
      document.querySelectorAll('.ch-acc-btn').forEach(b => b.classList.remove('is-open'));
      if (!isOpen) { body.classList.add('is-open'); btn.classList.add('is-open'); }
    });
  });

  /* Collection filter pills */
  document.querySelectorAll('.ch-filter-pill').forEach(pill => {
    pill.addEventListener('click', () => {
      document.querySelectorAll('.ch-filter-pill').forEach(p => p.classList.remove('is-active'));
      pill.classList.add('is-active');
      const tag = pill.dataset.tag;
      document.querySelectorAll('.ch-card').forEach(card => {
        if (!tag || tag === 'all') { card.style.display = ''; return; }
        const ct = (card.dataset.tags || '').toLowerCase().replace(/-/g, ' ');
        const ft = tag.toLowerCase().replace(/-/g, ' ');
        card.style.display = ct.includes(ft) ? '' : 'none';
      });
    });
  });

  /* Sort */
  document.getElementById('ch-sort')?.addEventListener('change', function() {
    const val  = this.value;
    const grid = document.querySelector('.ch-grid');
    if (!grid) return;
    const cards = [...grid.querySelectorAll('.ch-card')];
    cards.sort((a, b) => {
      const pa = parseFloat(a.querySelector('.ch-card__price')?.dataset.price || 0);
      const pb = parseFloat(b.querySelector('.ch-card__price')?.dataset.price || 0);
      if (val === 'price-asc') return pa - pb;
      if (val === 'price-desc') return pb - pa;
      return 0;
    });
    cards.forEach(c => grid.appendChild(c));
  });

  fetch('/cart.js').then(r => r.json()).then(cart => setCount(cart.item_count)).catch(() => {});
});
